<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-center">
    <div class="modal-title">Sell More</div>
    <button
      type="button"
      class="close close--paybee position-absolute"
      data-dismiss="modal"
      aria-label="Close"
      (click)="close(dialog, false)"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-2 text-center" style="font-size:13px">Please enter the amount or select from table.</div>
    <form [formGroup]="form">
        <mdb-form-control class="form-fill" >
          <app-mdbp-input mdbInput formControlName="amount" [isCurrencyMask]="true" placeholder="0" label='Enter Amount'>
            <input  #inputNameC currencyMask formControlName="amount" [options]="{ allowNegative: false, prefix: '$', inputMode: 1 }" placeholder="0" class="form-control form-control--paybee active"/>
          </app-mdbp-input>
      </mdb-form-control>
    </form>

    <table class="table w-100 table-hover" *ngIf="dataSource.length > 0">
      <thead>
        <tr>
          <th scope="col">
          </th>
          <th scope="col">Bidder</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>     
        <tr *ngFor="let item of dataSource, index as i">
          <th scope="row">
            <div class="form-check">
              <input class="form-check-input form-check-input--paybee checkbox" type="checkbox" value=""    
              (click)="show($event, item.amount)"
              (change)="$event ? selection.toggle(i) : null"
              [checked]="selection.isSelected(i)" [id]="i" />
            </div>
          </th>
          <td>{{item.userInfo.name}}</td>
          <td>{{item.amount}}</td>
      </tbody>
    </table>

  </div>
  <div class="modal-footer">
    <div class="row d-flex justify-content-center">
        <button
            type="button"
            class="btn btn--paybee btn--pink btn--md text-center"
            (click)="close(dialog, true)"
            [disabled]="!selection.hasValue() && form.invalid"
        >Confirm</button>
    </div>
  </div>
</ng-container>
